export enum Alphabet {
	'a',
	'b',
	'c',
	'd',
	'e',
}
